import { defineMessages } from 'react-intl';
import { CAMPAIGN_LEVEL, CAMPAIGN_TYPE } from './Campaigns.helpers';

export default {
  modals: defineMessages({
    endNowTitle: {
      id: 'campaigns.modals.end-now-title',
      defaultMessage: 'Are you sure you want to end it now?',
    },
    endNowDescription: {
      id: 'campaigns.modals.end-now-description',
      defaultMessage:
        'The members will no longer be able to use the discount within {flag, select, true {the {name}} other {this}} campaign. This action is irreversible.',
    },
  }),
  form: defineMessages({
    titleAdd: {
      id: 'campaigns.form.title.add',
      defaultMessage: 'Create campaign',
    },
    titleEdit: {
      id: 'campaigns.form.title.edit',
      defaultMessage: 'Edit campaign',
    },
    empty: {
      id: 'campaigns.form.empty',
      defaultMessage: 'No campaigns can be created at this time.',
    },
    labelCampaign: {
      id: 'campaigns.form.label.campaign',
      defaultMessage: 'Select campaign',
    },
    labelCampaignName: {
      id: 'campaigns.form.label.campaign-name',
      defaultMessage: 'Campaign name',
    },
    labelCampaignNameOptional: {
      id: 'campaigns.form.label.campaign-name-optional',
      defaultMessage: 'Campaign name (optional)',
    },
    labelDiscountAmount: {
      id: 'campaigns.form.label.discount-amount',
      defaultMessage: 'Discount amount',
    },
    labelGrow: {
      id: 'campaigns.form.label.grow',
      defaultMessage: 'How would you like to grow your business?',
    },
    labelServices: {
      id: 'campaigns.form.label.services',
      defaultMessage: 'Services',
    },
    labelStartDate: {
      id: 'campaigns.form.label.start-date',
      defaultMessage: 'Start date',
    },
    labelEndDate: {
      id: 'campaigns.form.label.end-date',
      defaultMessage: 'End date',
    },
    labelSetEndDate: {
      id: 'campaigns.form.label.set-end-date',
      defaultMessage: 'Set end date',
    },
    labelAllServices: {
      id: 'campaigns.form.label.all-services',
      defaultMessage: 'All Services',
    },
    labelAllClasses: {
      id: 'campaigns.form.label.all-classes',
      defaultMessage: 'All Classes',
    },
    labelSomeServices: {
      id: 'campaigns.form.label.some-services',
      defaultMessage: '{selected}/{total} selected',
    },
    labelSelectedServices: {
      id: 'campaigns.form.label.selected-services',
      defaultMessage: 'Selected services',
    },
    labelSelectedClasses: {
      id: 'campaigns.form.label.selected-classes',
      defaultMessage: 'Selected classes',
    },
    optionPercentage: {
      id: 'campaigns.form.label.option-percentage',
      defaultMessage: '{value}%',
    },
    placeholderCampaignName: {
      id: 'campaigns.form.placeholder.campaign-name',
      defaultMessage: 'e.g. Christmas sale',
    },
    placeholderDiscountAmount: {
      id: 'campaigns.form.placeholder.discount-amount',
      defaultMessage: 'Select amount',
    },
    placeholderEndDate: {
      id: 'campaigns.form.placeholder.end-date',
      defaultMessage: 'No end date',
    },
    btnAdd: {
      id: 'campaigns.form.button.launch-campaign',
      defaultMessage: 'Launch campaign',
    },
    btnEdit: {
      id: 'campaigns.form.button.edit',
      defaultMessage: 'Save',
    },
    btnConfirm: {
      id: 'campaigns.form.button.confirm',
      defaultMessage: 'Confirm',
    },
    btnCampaigns: {
      id: 'campaigns.form.button.campaigns',
      defaultMessage: 'Campaigns',
    },
    btnCancel: {
      id: 'campaigns.form.button.cancel',
      defaultMessage: 'Cancel',
    },
    btnEndNow: {
      id: 'campaigns.form.button.end-now',
      defaultMessage: 'End now',
    },
    errorStartDate: {
      id: 'campaigns.form.error.start-date-before-today',
      defaultMessage: 'Start date must not be in the past',
    },
    errorEndBeforeStart: {
      id: 'campaigns.form.error.end-date-before-start',
      defaultMessage: 'End date must be after start date',
    },
    errorEndBeforeToday: {
      id: 'campaigns.form.error.end-date-before-today',
      defaultMessage: 'End date must not be in the past',
    },
    errorNoDiscountSelected: {
      id: 'campaigns.form.error.no-discount',
      defaultMessage: 'A discount option must be selected',
    },
    errorNoServicesSelected: {
      id: 'campaigns.form.error.no-services',
      defaultMessage: 'At least 1 service needs to be chosen',
    },
  }),
  saga: defineMessages({
    createSuccess: {
      id: 'campaigns.saga.create-success',
      defaultMessage: 'Campaign created successfully!',
    },
    createError: {
      id: 'campaigns.saga.create-error',
      defaultMessage: 'An error occurred while creating the campaign. Please try again later.',
    },
    updateSuccess: {
      id: 'campaigns.saga.update-success',
      defaultMessage: 'Campaign pack updated successfully!',
    },
    updateError: {
      id: 'campaigns.saga.update-error',
      defaultMessage: 'An error occurred while updating the campaign. Please try again later.',
    },
    endSuccess: {
      id: 'campaigns.saga.end-success',
      defaultMessage: 'Campaign has been successfully ended',
    },
  }),
  table: defineMessages({
    headerCampaigns: {
      id: 'campaigns.table.header.campaigns',
      defaultMessage: 'Campaign',
    },
    headerAmount: {
      id: 'campaigns.table.amount',
      defaultMessage: 'Amount',
    },
    headerDuration: {
      id: 'campaigns.table.header.duration',
      defaultMessage: 'Duration',
    },
    headerServices: {
      id: 'campaigns.table.services',
      defaultMessage: 'Services',
    },
    headerClasses: {
      id: 'campaigns.table.classes',
      defaultMessage: 'Classes',
    },
    headerItems: {
      id: 'campaigns.table.items',
      defaultMessage: 'Items',
    },
    headerStatus: {
      id: 'campaigns.table.header.status',
      defaultMessage: 'Status',
    },
    headerRedemptions: {
      id: 'campaigns.table.header.redemptions',
      defaultMessage: 'Redemptions',
    },
    headerEarnings: {
      id: 'campaigns.table.header.earnings',
      defaultMessage: 'Earnings',
    },
    allServices: {
      id: 'campaigns.table.allServices',
      defaultMessage: 'All Services',
    },
    allClasses: {
      id: 'campaigns.table.allClasses',
      defaultMessage: 'All Classes',
    },
    allItems: {
      id: 'campaigns.table.allItems',
      defaultMessage: 'All Items',
    },
    duration: {
      id: 'campaigns.table.duration',
      defaultMessage:
        '{startDateTime, date, medium} - {endDateTime, select, null {Now} other {{endDateTime, date, medium}}}',
    },
    statusActive: {
      id: 'campaigns.table.status.active',
      defaultMessage: 'Active',
    },
    statusEnded: {
      id: 'campaigns.table.status.ended',
      defaultMessage: 'Ended',
    },
    statusUpcoming: {
      id: 'campaigns.table.status.upcoming',
      defaultMessage: 'Upcoming',
    },
    tooltipRedemptions: {
      id: 'campaigns.table.tooltip.redemptions',
      defaultMessage: '<strong>Note:</strong> Redemptions and earnings data updates weekly.',
    },
    tooltipEarnings: {
      id: 'campaigns.table.tooltip.earnings',
      defaultMessage: 'If applicable, inclusive of VAT/GST',
    },
    menuEdit: {
      id: 'campaigns.table.menu.edit',
      defaultMessage: 'Edit',
    },
    menuViewReport: {
      id: 'campaigns.table.menu.view-report',
      defaultMessage: 'View report',
    },
    menuEnded: {
      id: 'campaigns.table.menu.ended',
      defaultMessage: 'This campaign has ended.',
    },
    menuUneditable: {
      id: 'campaigns.table.menu.uneditable',
      defaultMessage: 'This campaign is not editable',
    },
    updatedMessage: {
      id: 'campaigns.table.updated-message',
      defaultMessage: '{dateTime, date, medium} by {name}',
    },
    moreServices: {
      id: 'campaigns.table.more-services',
      defaultMessage: ' +{count} more',
    },
    servicesSelected: {
      id: 'campaigns.table.services-selected',
      defaultMessage: '{count} services selected',
    },
    classesSelected: {
      id: 'campaigns.table.classes-selected',
      defaultMessage: '+{count} classes selected',
    },
    itemsSelected: {
      id: 'campaigns.table.items-selected',
      defaultMessage: '+{count} items selected',
    },
  }),

  nameOverrides: defineMessages({
    [CAMPAIGN_TYPE.ALL_USER]: {
      id: 'campaigns.type.name.override.all-user',
      defaultMessage: 'Grow your business fast',
    },
    [CAMPAIGN_TYPE.NEW_USER]: {
      id: 'campaigns.type.name.override.new-user',
      defaultMessage: 'Get new members',
    },
    [CAMPAIGN_TYPE.WINBACK]: {
      id: 'campaigns.type.name.override.winback',
      defaultMessage: 'Reactivate past members',
    },
  }),

  fnbNameOverrides: defineMessages({
    [CAMPAIGN_TYPE.ALL_USER]: {
      id: 'campaigns.type.name.fnb-override.all-user',
      defaultMessage: 'Grow your business fast',
    },
    [CAMPAIGN_TYPE.NEW_USER]: {
      id: 'campaigns.type.name.fnb-override.new-user',
      defaultMessage: 'Get new customers',
    },
    [CAMPAIGN_TYPE.WINBACK]: {
      id: 'campaigns.type.name.fnb-override.winback',
      defaultMessage: 'Reactivate past customers',
    },
  }),

  levelOverrides: defineMessages({
    [CAMPAIGN_LEVEL.VENUE]: {
      id: 'campaigns.level.name.override.venue',
      defaultMessage: 'Venue',
    },
    [CAMPAIGN_LEVEL.CLASS]: {
      id: 'campaigns.level.name.override.class',
      defaultMessage: 'Service',
    },
  }),

  descriptionOverrides: defineMessages({
    [CAMPAIGN_TYPE.ALL_USER]: {
      id: 'campaigns.type.description.override.all-user',
      defaultMessage: 'Applies to all members. Multiple active campaigns are possible.',
    },
    [CAMPAIGN_TYPE.NEW_USER]: {
      id: 'campaigns.type.description.override.new-user',
      defaultMessage: 'Applies to members who have not visited your business. Only one active campaign is possible.',
    },
    [CAMPAIGN_TYPE.WINBACK]: {
      id: 'campaigns.type.description.override.winback',
      defaultMessage:
        'Applies to members who have not visited your business in at least 3 months. Only one active campaign is possible.',
    },
  }),
};
